import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

type ActionButtonFunction = (...args) => void | boolean;

export interface IActionButton {
  buttonClass?:string;
  execute?:ActionButtonFunction;
  showExpression?:ActionButtonFunction;
  label?:string;
  iconClass?:string;
  busy?:boolean;
}

export interface IActionButtonGrid {
  enabled?:boolean;
  buttons?:IActionButton[];
}

export interface IActionButtonRendererParams extends ICellRendererParams {
  getActions(params:IActionButtonRendererParams):IActionButtonGrid[];
}

@Component({
  selector: 'ag-action-button',
  template: `
    <div *ngFor="let action of actions" class="action-button">
      <p class="no-margin" *ngIf="!action.enabled">&nbsp;</p>
      <ng-container *ngFor="let button of action.buttons; let buttonIndex = index;">
        <button class="btn" [ngClass]="button.buttonClass" (click)="button.execute(params, buttonIndex, $event)" *ngIf="button.showExpression(params, buttonIndex)" [busyButton]="button.busy">
          <i class="fa" [ngClass]="button.iconClass" *ngIf="button.iconClass"></i>&nbsp;
          <span>{{button.label}}</span>
        </button>
      </ng-container>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  styleUrls: [ './ag-action-button.scss' ]
})
export class AgActionButtonRendererComponent implements ICellRendererAngularComp {
  public params!:IActionButtonRendererParams;
  public actions:IActionButtonGrid[];

  public agInit(params:IActionButtonRendererParams):void {
    this.params = params;
    this.actions = this.params.getActions(this.params);
  }

  public refresh(params:IActionButtonRendererParams):boolean {
    this.params = params;
    this.actions = this.params.getActions(this.params);
    return true;
  }
}